<div
  [formGroup]="applicationParentForm"
  class="formGroup general-component"
  *ngIf="applicationParentForm.get('generalInfo')"
>
  <div class="mt-4" formGroupName="generalInfo">
    <div class="h5">General</div>
    <div class="mt-3">Search Preference</div>
    <div class="d-flex flex-row">
      <!-- <div class="form-group d-flex flex-row">
        <div class="custom-control custom-radio">
          <input
            type="radio"
            class="custom-control-input"
            formControlName="search"
            id="singleSearch"
            name="search"
            value="singleSearch"
            checked="true"
          />
          <label
            class="white-space-nowrap"
            class="custom-control-label"
            for="singleSearch"
            >Single Search Fields</label
          >
        </div>
      </div> -->
      <div class="form-group">
        <div
          class="custom-control custom-checkbox custom-control-inline mr-3"
          name="useCustomPlaces"
        >
          <input
            type="checkbox"
            formControlName="useCustomPlaces"
            class="custom-control-input"
            id="useCustomPlaces"
          />
          <label
            class="white-space-nowrap"
            class="custom-control-label"
            for="useCustomPlaces"
            >Use Custom Places</label
          >
        </div>
      </div>
      <div class="form-group">
        <div
          class="custom-control custom-checkbox custom-control-inline mr-3"
          name="includePlaces"
        >
          <input
            type="checkbox"
            formControlName="includePlaces"
            class="custom-control-input"
            id="includePlaces"
          />
          <label
            class="white-space-nowrap"
            class="custom-control-label"
            for="includePlaces"
            >Include Places (Businesses, Attractions, etc...)</label
          >
        </div>
      </div>
      <div class="form-group" style="min-width: 10%">
        <div class="custom-control custom-checkbox">
          <input
            class="custom-control-input"
            type="checkbox"
            formControlName="useMapCenter"
            id="useMapCenter"
          />
          <label
            class="white-space-nowrap"
            class="custom-control-label"
            for="useMapCenter"
          >
            Use Map Center For Relevance
          </label>
        </div>
      </div>
      <div class="form-group p-1">
        <label class="white-space-nowrap" for="radiusFromCurrentLonLat"
          >Radius From Map Center</label
        >
        <input
          type="number"
          class="form-control"
          formControlName="radiusFromCurrentLonLat"
          id="radiusFromCurrentLonLat"
          placeholder="Radius In Miles"
          min="1"
          max="20"
          [ngClass]="{
            'is-invalid': generalFormControls?.radiusFromCurrentLonLat?.errors
          }"
        />
        <div
          *ngIf="
            generalFormControls?.radiusFromCurrentLonLat?.dirty &&
            generalFormControls?.radiusFromCurrentLonLat?.errors
          "
          class="invalid-feedback"
        >
          <div
            *ngIf="generalFormControls?.radiusFromCurrentLonLat?.errors?.min"
          >
            The value cannot be less than 1
          </div>
          <div
            *ngIf="generalFormControls?.radiusFromCurrentLonLat?.errors?.max"
          >
            The value cannot be more than 20
          </div>
        </div>
      </div>
    </div>
    <div class="d-flex flex-row">
      <div class="form-group">
        <label class="white-space-nowrap" for="noOfMaxResults"
          >Number of Results</label
        >
        <input
          type="number"
          class="form-control"
          formControlName="noOfMaxResults"
          id="noOfMaxResults"
          placeholder="Max Result"
          min="1"
          max="200"
          required
          [ngClass]="{
            'is-invalid': generalFormControls?.noOfMaxResults?.errors
          }"
        />
        <div
          *ngIf="
            generalFormControls?.noOfMaxResults?.dirty &&
            generalFormControls?.noOfMaxResults?.errors
          "
          class="invalid-feedback"
        >
          <div *ngIf="generalFormControls?.noOfMaxResults?.errors?.required">
            Number of max result is required
          </div>
          <div *ngIf="generalFormControls?.noOfMaxResults?.errors?.min">
            Total Number of Result cannot be less than 1
          </div>
          <div *ngIf="generalFormControls?.noOfMaxResults?.errors?.max">
            Total Number of Result cannot be more than 200
          </div>
        </div>
      </div>
      <div class="form-group">
        <label class="white-space-nowrap" for="countries">Countries</label>
        <mat-select
          placeholder="Countries"
          id="country"
          formControlName="countries"
          class="form-control"
          multiple
        >
          <mat-option
            *ngFor="let country of countryOptions"
            [value]="country.FIPS"
            >{{ country.Name }}</mat-option
          >
        </mat-select>
      </div>
      <div class="form-group">
        <label class="white-space-nowrap" for="states">States</label>
        <mat-select
          placeholder="States"
          id="state"
          formControlName="states"
          class="form-control"
          multiple
        >
          <mat-option
            *ngFor="let state of stateOptions"
            [value]="state.Abbrev"
            >{{ state.Name }}</mat-option
          >
        </mat-select>
      </div>
      <div class="form-group">
        <label class="white-space-nowrap" for="plcaeTypes">Place Types</label>
        <mat-select
          placeholder="Place Types"
          id="poiTypes"
          formControlName="poiTypes"
          class="form-control"
          multiple
        >
          <mat-option
            *ngFor="let placeType of placeTypeOptions"
            [value]="placeType.Name"
          >
            {{ placeType.Name }}</mat-option
          >
        </mat-select>
      </div>
      <div class="form-group">
        <label class="white-space-nowrap" for="excludeTypes"
          >Excluded Result Types</label
        >
        <mat-select
          placeholder="Excluded Types"
          id="ExcludedTypes"
          class="form-control"
          formControlName="excludeTypes"
          multiple
        >
          <mat-option
            *ngFor="let excludeType of excludeTypes"
            [value]="excludeType.value"
            [disabled]="excludeType.disable"
            >{{ excludeType.value }}</mat-option
          >
        </mat-select>
      </div>
      <div class="form-group">
        <label class="white-space-nowrap" for="includeTypes"
          >Included Result Types</label
        >
        <mat-select
          placeholder="Included Types"
          id="IncludedTypes"
          class="form-control"
          formControlName="includeTypes"
          multiple
        >
          <mat-option
            *ngFor="let includeType of includeTypes"
            [value]="includeType.value"
            [disabled]="includeType.disable"
            >{{ includeType.value }}</mat-option
          >
        </mat-select>
      </div>
    </div>
    <div class="mt-3">Display Preference</div>
    <div class="d-flex flex-row">
      <div class="form-group">
        <label for="roundOffDistValues" class="white-space-nowrap"
          >Maximum Distance Unit Precision</label
        >
        <select
          id=" roundOffDistValues"
          class="form-control"
          formControlName="precision"
        >
          <option
            *ngFor="let option of roundOffDistanceUnit"
            [value]="option.value"
          >
            {{ option.display }}
          </option>
        </select>
      </div>
    </div>
  </div>
</div>
